jQuery(document).ready(function($) {

    $( ".bloc_separateur" ).each(function( index ) {

        var parent = $(this)
        var cadre = parent.find(".contenu")

        // décalage réduit sous 1024px : le bloc est moins haut, l'encart
        // déborderait sur le bloc suivant
        gsap.from( cadre, {
            y : function () {
                return window.matchMedia("(max-width: 1023.98px)").matches ? 60 : 200
            },
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "bottom 100%",
                scrub: 1,
                invalidateOnRefresh: true,
            }

        })

    })

});